<template>
  <div class="content">
    <div class="short-risk">
      <!-- <div class="p-time">监测时间：{{ $moment(riskShort.ddatetime).format('YYYY-MM-DD HH:mm')}}</div> -->
      <div class="risk-list">
        <div class="risk-item">
          <span>要素/时间</span>
          <span
            v-for="(item, index) in riskResult.times"
            :key="index + ''"
            v-html="item"
          ></span>
        </div>
        <div
          class="risk-item"
          v-for="(item, key) in riskResult.data"
          :key="key"
        >
          <span>{{ key }}</span>
          <template v-if="key === '龙卷'">
            <span v-for="index1 in riskResult.times.length" :key="index1 + ''">
              <i
                v-if="riskResult.data[key][index1 - 1] != null"
                :style="{
                  background:
                    item[index1 - 1] == 1
                      ? '#f05179'
                      : item[index1 - 1] == 2
                        ? '#fac005'
                        : item[index1 - 1] == 3
                          ? '#3c8e33'
                          : item[index1 - 1] == 4
                            ? '#7ae4a5'
                            : '',
                }"
              >
                <i class="pounp">{{
                  riskResult.data[key][index1 - 1] != null
                    ? cbcLevelMap[riskResult.data[key][index1 - 1].toFixed(0)]
                    : "--"
                }}</i>
              </i>
            </span>
          </template>
          <template v-else>
            <span v-for="index1 in riskResult.times.length" :key="index1 + ''">
              <i
                :style="{
                  background:
                    item[index1 - 1] == 1
                      ? 'red'
                      : item[index1 - 1] == 2
                        ? 'orange'
                        : item[index1 - 1] == 3
                          ? '#ffd90a'
                          : item[index1 - 1] == 4
                            ? 'blue'
                            : item[index1 - 1] == 5
                              ? '#FFF'
                              : '',
                }"
              >
                <i class="pounp">{{
                  riskResult.data[key][index1 - 1]
                    ? levelMap[riskResult.data[key][index1 - 1].toFixed(0)]
                    : "--"
                }}</i>
              </i>
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  props: ["params", "forecastType"],
  data() {
    return {
      riskType: 0,
      riskShort: {},
      riskFore: {},
      stp: {},
      levelMap: {
        1: "高",
        2: "中",
        3: "低",
      },
      cbcLevelMap: {
        0: "--",
        1: "超高",
        2: "高",
        3: "中",
        4: "低",
      },
    };
  },

  watch: {
    riskForeResult() {
      setTimeout(() => {
        this.getRiskData();
      }, 100);
    },
    stpResult() {
      setTimeout(() => {
        this.getStp();
      }, 100);
    },
  },
  computed: {
    ...mapState("home", [
      "objsList",
      "activeCountyId",
      "cartData",
      "riskForeResult",
      "stpResult",
    ]),
    riskResult() {
      const result = {
        times: [],
        data: {},
      };
      const stp = JSON.parse(JSON.stringify(this.stp));
      console.log("stp", stp);
      if (this.riskFore && this.riskFore.data) {
        const weatherData = this.riskFore.data;
        const weatherTime = this.riskFore.times;
        for (const key in weatherData) {
          if (!result.data[key]) {
            result.data[key] = [];
          }
          result.data[key].push(...weatherData[key].slice(0, 6));
        }
        const times = weatherTime
          .slice(0, 6)
          .map((v) => v.replace("未来", "未来<br>").replace("月", "月<br>"));
        result.times.push(...times);
        console.log("this.stp.data", this.stp);
        // 如果龙卷存在 那么展示龙卷
        if (stp && stp.data) {
          const stpData = stp.data;
          console.log("stpData", stpData);
          const stpTimes = this.stp.times.map((v) => v.replace("月", "月<br>"));
          for (const key in stpData) {
            const stpTmpData = new Array(result.times.length).fill(null);
            // if (index !== -1) {
            //   for (let i = 0; i < index; i++) {
            //     stpData.splice(0, 0, null)
            //   }
            // }
            // result.data[key] = stpData
            for (let i = 0; i < result.times.length; i++) {
              for (let j = 0; j < stpTimes.length; j++) {
                if (result.times[i] === stpTimes[j]) {
                  stpTmpData[i] = stpData[key][j];
                }
              }
            }
            console.log("stpTmpData", stpTmpData);
            result.data[key] = stpTmpData;
          }
        }
      }
      return result;
    },
  },
  mounted() {
    setTimeout(() => {
      this.getRiskData();
    }, 100);
    setTimeout(() => {
      this.getStp();
    }, 100);
  },
  methods: {
    ...mapMutations("home", ["changeCartItem"]),
    /**
     * 短临风险
     */
    async getRiskData() {
      this.riskFore = this.riskForeResult;
    },
    async getStp() {
      this.stp = this.stpResult;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.8vw 1.04vw 1.04vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;

  .short-risk {
    height: 100%;
    // padding: 10% 8% 4% 8%;
    // padding: 3.13vw 1.04vw 1.04vw 1.04vw;
    box-sizing: border-box;
  }

  .risk-list {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .risk-item {
      font-size: 0.88rem;
      color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 0.6vw;

      &:hover {
        cursor: pointer;
      }

      span:nth-child(1) {
        text-align: center;
        width: 3.64vw;
      }

      span {
        width: 74px;
        display: inline-block;
        text-align: center;
        margin: 0vw 0.16vw;

        i {
          display: inline-block;
          position: relative;
          width: 3.27rem;
          height: 0.63rem;
          background: #295073;
          border-radius: 0.31rem;

          &:hover {
            .pounp {
              display: block;
            }
          }

          .pounp {
            display: none;
            position: absolute;
            bottom: 0.8vw;
            left: 50%;
            transform: translateX(-50%);
            width: 3.27rem;
            height: 1.36vw;
            line-height: 1.36vw;
            background: #052c4d;
            color: #fff;
            box-shadow: 0px 2px 18px 0px rgba(139, 157, 189, 0.35);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;

            &::after {
              content: "";
              display: inline-block;
              position: absolute;
              left: 50%;
              bottom: -10px;
              transform: translateX(-50%);
              border: 5px solid transparent;
              border-top-color: rgba(255, 255, 255, 0.8);
              box-shadow: 0px 2px 18px 0px rgba(139, 157, 189, 0.35);
            }
          }
        }
      }
    }

    .risk-item:nth-child(1) {
      height: 2.14vw;
      background: #052c4d;
      border-radius: 0.21vw;
    }
  }
}
</style>
